<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout column class="eservice_inner_wrap">
      <h2 class="outside_title d-flex">
        {{ $t('application.patent.title') }}
        <v-spacer></v-spacer>
        <span class="loc_postion">
          <span class="front_loc">{{ $t('application.title') }} > </span>
          <span class="middle_loc">{{ $t('application.patent.title2') }} > </span>
          <span class="back_loc">{{ $t('common.common.new') }}</span>
        </span>
      </h2>
      <v-layout column class="ma-0 pos-r center__wrapper">
        <v-flex class="inner_basic_wrap type2">
          <v-layout class="step_wrapper type3">
            <v-flex class="step_box step01 cursor_pointer" @click="fnGoBefore()">
              <h2>{{ $t('application.patent.fields.step_01') }}</h2>
              <p v-html="$t('application.patent.fields.select_type_and_input')"></p>
            </v-flex>
            <v-flex class="active step_box step02">
              <h2>{{ $t('application.patent.fields.step_02') }}</h2>
              <p>{{ $t('application.patent.fields.write_application') }}</p>
            </v-flex>
            <v-flex class="step_box step03">
              <h2>{{ $t('application.patent.fields.step_03') }}</h2>
              <p>{{ $t('application.patent.fields.attach_file(s)') }}</p>
            </v-flex>
            <v-flex class="step_box step04">
              <h2>{{ $t('application.patent.fields.step_04') }}</h2>
              <p>{{ $t('application.patent.fields.review_submit') }}</p>
            </v-flex>
            <v-flex class="step_box step05">
              <h2>{{ $t('application.patent.fields.step_05') }}</h2>
              <p>{{ $t('application.patent.fields.payment') }}</p>
            </v-flex>
          </v-layout>
          <v-layout class="inner_contents mt-30" column>
            <v-flex>
              <h3 class="sub_title_box">{{ $t('application.patent.fields.applicants_s') }}</h3>

              <Applicants
                :receipt_no.sync="receipt_no"
                :userInfo="userInfo"
                :company="company"
                :auto_insert="auto_insert_applicant"
                v-if="flag_applicant"
                ref="component_applicants"
                @success="fnRefreshComponent"
              />
            </v-flex>

            <v-flex>
              <h3 class="sub_title_box mt-25 pr-20">
                {{ $t('application.patent.fields.inventor_s') }}
                <v-spacer></v-spacer>
                <v-btn
                  color="#333"
                  outlined
                  dark
                  height="25"
                  class="btn-normal ft-size11"
                  @click="getApplicantForInventor()"
                >
                  {{ $t('application.patent.fields.get_the_applicants_information') }}
                </v-btn>
              </h3>
              <Inventor
                :receipt_no.sync="receipt_no"
                :userInfo="userInfo"
                :company="company"
                v-if="flag_inventor"
                ref="component_inventors"
                @success="fnRefreshComponent"
              />
            </v-flex>

            <v-flex>
              <h3 class="sub_title_box mt-25 pr-20">
                {{ $t('application.patent.fields.representative') }}
                <v-spacer></v-spacer>
                <v-btn
                  color="#333"
                  dark
                  outlined
                  height="25"
                  class="btn-normal ft-size11"
                  @click="getApplicantForRepresentative()"
                >
                  {{ $t('application.patent.fields.get_the_applicants_information') }}
                </v-btn>
              </h3>
              <Representative
                :receipt_no.sync="receipt_no"
                :userInfo="userInfo"
                :company="company"
                :auto_insert="auto_insert_representative"
                v-if="flag_representative"
                ref="component_representative"
                @success="fnRefreshComponent"
                @SET_REPRESENTATIVE_NEWABLE="fnSetRepresentativeNewable"
              />
            </v-flex>

            <v-flex>
              <h3 class="sub_title_box mt-25">
                {{ $t('application.patent.fields.priority_claim') }}
              </h3>
            </v-flex>
            <v-row class="ma-0">
              <v-col class="pa-0">
                <v-data-table
                  disable-sort
                  :headers="$getHeaderType1(priorityHeaderTxt, priorityHeaders)"
                  :items="priorityList"
                  hide-default-footer
                  disable-pagination
                  class="new__type__table__view"
                  :mobile-breakpoint="MobileBreakPoint"
                >
                  <template v-slot:item="{ item, index }">
                    <tr>
                      <td>{{  priorityList.length - index  }}</td>
                      <td class="text-center">{{ convertDateForm(item.priority_date) }}</td>
                      <td>{{ item.priority_no }}</td>
                      <td>{{ item.priority_country_code }}</td>
                      <td class="text-left">
                        <template v-if="!fnIsNull(item.priority_ar_file_key) && !fnIsNull(item.priority_en_file_key)">
                          <div class="pt--10">
                            <v-icon>mdi-file-pdf</v-icon>
                            {{ item.priority_ar_file_name }}
                          </div>
                          <br>
                          <div class="pb--10">
                            <v-icon>mdi-file-pdf</v-icon>
                            {{ item.priority_en_file_name }}
                          </div>
                        </template>
                        <template v-if="!fnIsNull(item.priority_ar_file_key) && fnIsNull(item.priority_en_file_key)">
                          <div>
                            <v-icon>mdi-file-pdf</v-icon>
                            {{ item.priority_ar_file_name }}
                          </div>
                        </template>
                        <template v-if="fnIsNull(item.priority_ar_file_key) && !fnIsNull(item.priority_en_file_key)">
                          <div>
                            <v-icon>mdi-file-pdf</v-icon>
                            {{ item.priority_en_file_name }}
                          </div>
                        </template>
                      </td>
                      <td>
                        <div class="d-flex">
                          <v-btn icon @click="fnShowPriorityModDialog(item.seq)">
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn icon @click="fnPriorityDeleteConfirm(item.seq)">
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </div>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
            <v-layout class="mt-20">
                <v-spacer/>
                <v-btn class="ft-size12 text-capitalize" color="#a01c2a" dark outlined dense width="110px" height="40px" @click="fnShowPriorityAddDialog()">{{ $t('common.button.add') }}</v-btn>
            </v-layout>
            <v-flex>
              <h3 class="sub_title_box mt-25">
                {{ $t('application.patent.fields.temporary_protection') }}
              </h3>
            </v-flex>
            <v-row class="ma-0">
              <v-col class="pa-0">
                <v-data-table
                  disable-sort
                  :headers="$getHeaderType1(temporaryHeaderTxt, temporaryHeaders)"
                  :items="temporaryList"
                  hide-default-footer
                  disable-pagination
                  class="new__type__table__view"
                  :mobile-breakpoint="MobileBreakPoint"
                >
                  <template v-slot:item="{ item, index }">
                    <tr>
                      <td>{{  temporaryList.length - index  }}</td>
                      <td>{{ item.exhibition_country_code }}</td>
                      <td>{{ ($vuetify.rtl) ? item.exhibition_name_ar : item.exhibition_name_en }}</td>
                      <td>{{ convertDateForm(item.opening_date) }}</td>
                      <td>{{ convertDateForm(item.protection_date) }}</td>
                      <td class="text-left">
                        <v-icon>mdi-file-pdf</v-icon>
                        {{ item.certificate_file_name }}
                      </td>
                      <td>
                        <div class="d-flex">
                          <v-btn icon @click="fnShowTemporaryModDialog(item.seq)">
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn icon @click="fnTemporaryDeleteConfirm(item.seq)">
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </div>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
            <v-layout class="mt-20">
                <v-spacer/>
                <v-btn class="ft-size12 text-capitalize" color="#a01c2a" dark outlined dense width="110px" height="40px" @click="fnShowTemporaryAddDialog()">{{ $t('common.button.add') }}</v-btn>
            </v-layout>
          </v-layout>

          <v-layout class="btn_wraps mt-40">
            <v-flex class="flex_0">
              <v-btn
                dense
                dark
                color="#acb0b3"
                min-width="150"
                min-height="50"
                class="btn-normal br_none"
                @click="fnGoBefore()"
                :loading="loadingBefore"
                :disabled="loadingBefore"
              >{{ $t('common.button.before') }}</v-btn>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex class="flex_0">
              <v-btn
                color="#a01c2a"
                dark
                min-width="150"
                min-height="50"
                class="btn-normal br_none"
                @click="fnGoNext()"
                :loading="loadingNext"
                :disabled="loadingNext"
              >
                {{ $t('common.button.next') }}
                <v-icon dark right>mdi-check</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>

        </v-flex>
      </v-layout>
    </v-layout>


    <!-- add priority claim -->
    <v-dialog  v-model="priorityAddDialog" flat persistent max-width="900" content-class="br_none">
      <v-row class="modal__content__wrapper">
        <v-col cols="12" class="pa-0">
          <div class="header__wrap">
            <div>
              <h2 class="modal__title">{{ $t('application.patent.fields.add_priority_claim') }}</h2>
            </div>
            <div class="modal__close__wrap">
              <v-btn @click="fnHidePriorityAddDialog()"></v-btn>
            </div>
          </div>
        </v-col>

        <v-col>
          <ValidationObserver ref="addPriority">
            <v-form
              lazy-validation
            >
              <div class="modal__content__inner__new">
                 <v-card-text class="pa-0 inner_item_content bd_none">
                  <v-row>
                    <v-col cols="12" md="4">
                      <h2 class="nec_title"><i>*</i> {{ $t('application.patent.fields.where_earlier_application') }}</h2>
                      <div class="input_text_type_basic mt-15">
                        <v-select
                          dense
                          outlined
                          class="ft-size12"
                          v-model="addPriority.priority_country_code"
                          :items="($vuetify.rtl) ? countryArList : countryEnList"
                        >
                        </v-select>
                      </div>
                    </v-col>
                    <v-col cols="12" md="4">
                      <h2 class="nec_title"><i>*</i> {{ $t('application.patent.fields.number_of_earlier_application') }}</h2>
                      <div class="input_text_type_basic mt-15">
                        <ValidationProvider v-slot="{ errors }" :name="$t('application.patent.fields.number_of_earlier_application')" :rules="{required: true}">
                          <v-text-field
                            dense
                            outlined
                            clearable
                            maxlength="64"
                            class="ft-size12 login_text_field"
                            v-model="addPriority.priority_no"
                            :error-messages="errors"
                            ref="add_priority_no"
                          >
                          </v-text-field>
                        </ValidationProvider>
                      </div>
                    </v-col>
                    <v-col cols="12" md="4">
                      <h2 class="nec_title"><i>*</i> {{ $t('application.patent.fields.filing_date') }}</h2>
                      <div class="input_text_type_basic mt-15">
                        <v-menu
                          ref="priorityAddMenu"
                          v-model="priorityAddMenu"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          max-width="290px"
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <ValidationProvider v-slot="{ errors }" :name="$t('application.patent.fields.filing_date')" :rules="{required: true}">
                              <v-text-field
                                solo
                                dense
                                flat
                                outlined
                                readonly
                                v-on="on"
                                v-bind="attrs"
                                append-icon="mdi-calendar"
                                class="br_none date_type login_text_field"
                                hint="DD/MM/YYYY format"
                                v-model="priorityAddViewDate"
                                :error-messages="errors"
                                @click:append="priorityAddMenu = true"
                              ></v-text-field>
                            </ValidationProvider>
                          </template>
                          <v-date-picker v-model="priorityAddDate" no-title @input="fnSetPriorityAddDate()"></v-date-picker>
                        </v-menu>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row class="mt-25">
                    <v-col cols="12" md="8">
                      <h2 class="nec_title">{{ $t('application.patent.fields.attach_certified_copy_of_priority_followed_document_ar') }}</h2>
                      <div class="input_text_type_basic file_type mt-15 fileForm">
                        <v-file-input
                          dense
                          outlined
                          :placeholder="$t('application.patent.fields.no_files_selected')"
                          :prepend-icon="$t('common.common.select_file')"
                          class="ft-size12"
                          v-model="addPriorityFileAr"
                          style="height : 40px;"
                          accept=".pdf, .jpg, .gif"
                          @change="fnChangePriorityAddFileAr()"
                          clearable
                          @click:clear="fnInitPriorityAr()"
                        >
                        </v-file-input>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row class="mt-25">
                    <v-col cols="12" md="8">
                      <h2 class="nec_title">{{ $t('application.patent.fields.attach_certified_copy_of_priority_followed_document_en') }}</h2>
                      <div class="input_text_type_basic file_type mt-15 fileForm">
                        <v-file-input
                          dense
                          outlined
                          :placeholder="$t('application.patent.fields.no_files_selected')"
                          :prepend-icon="$t('common.common.select_file')"
                          class="ft-size12"
                          v-model="addPriorityFileEn"
                          style="height : 40px;"
                          accept=".pdf, .jpg, .gif"
                          @change="fnChangePriorityAddFileEn()"
                          clearable
                          @click:clear="fnInitPriorityEn()"
                        >
                        </v-file-input>
                      </div>
                    </v-col>
                  </v-row>
                  <v-card-actions class="pl-0 pr-0 mt-25">
                    <v-btn
                      dense
                      height="50"
                      width="150"
                      outlined
                      rounded
                      color="#a01c2a"
                      class="capitalize btn_basic"
                      @click.stop="fnHidePriorityAddDialog()"
                    >
                      {{ $t('common.button.cancel') }}
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                      dense
                      rounded
                      outlined
                      height="50"
                      width="150"
                      color="#a01c2a"
                      class="capitalize btn_basic"
                      @click.stop="fnPriorityAddBtn()"
                    >
                      {{ $t('common.button.add') }}
                    </v-btn>
                  </v-card-actions>
                </v-card-text>
              </div>
            </v-form>
          </ValidationObserver>
        </v-col>
      </v-row>

    </v-dialog>

    <!-- mod priority claim -->
    <v-dialog  v-model="priorityModDialog" flat persistent max-width="900" content-class="br_none">
      <v-row class="modal__content__wrapper">
        <v-col cols="12" class="pa-0">
          <div class="header__wrap">
            <div>
              <h2 class="modal__title">{{ $t('application.patent.fields.mod_priority_claim') }}</h2>
            </div>
            <div class="modal__close__wrap">
              <v-btn @click="fnHidePriorityModDialog()"></v-btn>
            </div>
          </div>
        </v-col>

        <v-col>
          <ValidationObserver ref="modPriority">
            <v-form
              lazy-validation
            >
              <div class="modal__content__inner__new">
                  <v-card-text class="pa-0 inner_item_content bd_none">
                  <v-row>
                    <v-col cols="12" md="4">
                      <h2 class="nec_title"><i>*</i> {{ $t('application.patent.fields.where_earlier_application') }}</h2>
                      <div class="input_text_type_basic mt-15">
                        <v-select
                          dense
                          outlined
                          class="ft-size12"
                          v-model="modPriority.priority_country_code"
                          :items="($vuetify.rtl) ? countryArList : countryEnList"
                        >
                        </v-select>
                      </div>
                    </v-col>
                    <v-col cols="12" md="4">
                      <h2 class="nec_title"><i>*</i> {{ $t('application.patent.fields.number_of_earlier_application') }}</h2>
                      <div class="input_text_type_basic mt-15">
                        <ValidationProvider v-slot="{ errors }" :name="$t('application.patent.fields.number_of_earlier_application')" :rules="{required: true}">
                          <v-text-field
                            dense
                            outlined
                            clearable
                            maxlength="64"
                            class="ft-size12 login_text_field"
                            v-model="modPriority.priority_no"
                            :error-messages="errors"
                            ref="mod_priority_no"
                          >
                          </v-text-field>
                        </ValidationProvider>
                      </div>
                    </v-col>
                    <v-col cols="12" md="4">
                      <h2 class="nec_title"><i>*</i> {{ $t('application.patent.fields.filing_date') }}</h2>
                      <div class="input_text_type_basic mt-15">
                        <v-menu
                          ref="priorityModMenu"
                          v-model="priorityModMenu"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          max-width="290px"
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <ValidationProvider v-slot="{ errors }" :name="$t('application.patent.fields.filing_date')" :rules="{required: true}">
                              <v-text-field
                                solo
                                dense
                                flat
                                outlined
                                readonly
                                v-on="on"
                                v-bind="attrs"
                                append-icon="mdi-calendar"
                                class="br_none date_type login_text_field"
                                hint="DD/MM/YYYY format"
                                v-model="priorityModViewDate"
                                :error-messages="errors"
                                @click:append="priorityModMenu = true"
                              ></v-text-field>
                            </ValidationProvider>
                          </template>
                          <v-date-picker v-model="priorityModDate" no-title @input="fnSetPriorityModDate()"></v-date-picker>
                        </v-menu>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row class="mt-25">
                    <v-col cols="12" md="8">
                      <h2 class="nec_title">{{ $t('application.patent.fields.attach_certified_copy_of_priority_followed_document_ar') }}</h2>
                      <div class="input_text_type_basic file_type mt-15 fileForm">
                        <v-file-input
                          dense
                          outlined
                          :placeholder="modPriorFileArExst && !modPriorFileArChg ? modPriority.priority_ar_file_name : $t('application.patent.fields.no_files_selected')"
                          :prepend-icon="$t('common.common.select_file')"
                          class="ft-size12"
                          v-model="modPriorityFileAr"
                          style="height : 40px;"
                          accept=".pdf, .jpg, .gif"
                          @change="fnChangePriorityModFileAr()"
                          clearable
                          @click:clear="fnInitPriorityModAr()"
                          :append-icon="modPriority.priority_ar_file_name ? '$clear':''"
                          @click:append="fnInitPriorityModAr()"
                        >
                        </v-file-input>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row class="mt-25">
                    <v-col cols="12" md="8">
                      <h2 class="nec_title">{{ $t('application.patent.fields.attach_certified_copy_of_priority_followed_document_en') }}</h2>
                      <div class="input_text_type_basic file_type mt-15 fileForm">
                        <v-file-input
                          dense
                          outlined
                          :placeholder="modPriorFileEnExst && !modPriorFileEnChg ? modPriority.priority_en_file_name : $t('application.patent.fields.no_files_selected')"
                          :prepend-icon="$t('common.common.select_file')"
                          class="ft-size12"
                          v-model="modPriorityFileEn"
                          style="height : 40px;"
                          accept=".pdf, .jpg, .gif"
                          @change="fnChangePriorityModFileEn()"
                          clearable
                          @click:clear="fnInitPriorityModEn()"
                          :append-icon="modPriority.priority_en_file_name ? '$clear':''"
                          @click:append="fnInitPriorityModEn()"
                        >
                        </v-file-input>
                      </div>
                    </v-col>
                  </v-row>
                  <v-card-actions class="pl-0 pr-0 mt-25">
                    <v-btn
                      dense
                      height="50"
                      width="150"
                      outlined
                      rounded
                      color="#a01c2a"
                      class="capitalize btn_basic"
                      @click.stop="fnHidePriorityModDialog()"
                    >
                      {{ $t('common.button.cancel') }}
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                      dense
                      height="50"
                      width="150"
                      dark
                      rounded
                      color="#a01c2a"
                      class="capitalize btn_basic"
                      @click.stop="fnPriorityModBtn()"
                    >
                      {{ $t('common.button.save') }}
                    </v-btn>
                  </v-card-actions>
                </v-card-text>
              </div>
            </v-form>
          </ValidationObserver>
        </v-col>
      </v-row>



    </v-dialog>

    <!-- add temporary protection -->
    <v-dialog  v-model="temporaryAddDialog" flat persistent max-width="900" content-class="br_none">
      <v-row class="modal__content__wrapper">
        <v-col cols="12" class="pa-0">
          <div class="header__wrap">
            <div>
              <h2 class="modal__title">{{ $t('application.patent.fields.add_temporary_protection') }}</h2>
            </div>
            <div class="modal__close__wrap">
              <v-btn @click="fnHideTemporaryAddDialog()"></v-btn>
            </div>
          </div>
        </v-col>

        <v-col>
          <ValidationObserver ref="addTemporary">
            <v-form
              lazy-validation
            >
              <div class="modal__content__inner__new">
                <v-card-text class="pa-0 inner_item_content bd_none">
                  <v-row>
                    <v-col cols="12">
                      <label class="nec_title"><i>*</i> {{ $t('application.patent.fields.exhibition_name') }}</label>
                      <div class="input_text_type_basic">
                        <ValidationProvider v-slot="{ errors }" :name="$t('application.patent.fields.exhibition_name')" :rules="{required: true}">
                          <v-text-field
                            dense
                            outlined
                            clearable
                            maxlength="1024"
                            class="ft-size12 login_text_field br_none"
                            v-model="addTemporary.exhibition_name_en"
                            :error-messages="errors"
                          >
                          </v-text-field>
                        </ValidationProvider>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="4" class="pt-0 pb-0">
                      <label class="nec_title"><i>*</i> {{ $t('application.patent.fields.country') }}</label>
                      <div class="input_text_type_basic">
                        <v-select
                          dense
                          outlined
                          class="ft-size12 br_none"
                          :items="($vuetify.rtl) ? countryArList : countryEnList"
                          v-model="addTemporary.exhibition_country_code"
                        >
                        </v-select>
                      </div>
                    </v-col>
                    <v-col cols="12" md="4" class="pt-0 pb-0">
                      <label class="nec_title"><i>*</i> {{ $t('application.patent.fields.exhibition_opening_date') }}</label>
                      <div class="input_text_type_basic">
                        <v-menu
                          ref="temporaryAddMenu1"
                          v-model="temporaryAddMenu1"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          max-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <ValidationProvider v-slot="{ errors }" :name="$t('application.patent.fields.exhibition_opening_date')" :rules="{required: true}">
                              <v-text-field
                                solo
                                flat
                                dense
                                outlined
                                readonly
                                v-on="on"
                                v-bind="attrs"
                                hint="DD/MM/YYYY format"
                                append-icon="mdi-calendar"
                                class="ft-size12 login_text_field br_none"
                                v-model="temporaryAddViewDate1"
                                :error-messages="errors"
                                @click:append="temporaryAddMenu2 = true"
                              ></v-text-field>
                            </ValidationProvider>
                          </template>
                          <v-date-picker v-model="temporaryAddDate1" no-title @input="fnSetTemporaryAddDate1()"></v-date-picker>
                        </v-menu>
                      </div>
                    </v-col>
                    <v-col cols="12" md="4" class="pt-0 pb-0">
                      <label class="nec_title"><i>*</i> {{ $t('application.patent.fields.date_of_protection') }}</label>
                      <div class="input_text_type_basic">
                        <v-menu
                          ref="temporaryAddMenu2"
                          v-model="temporaryAddMenu2"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          max-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <ValidationProvider v-slot="{ errors }" :name="$t('application.patent.fields.date_of_protection')" :rules="{required: true}">
                              <v-text-field
                                solo
                                flat
                                dense
                                outlined
                                readonly
                                v-on="on"
                                v-bind="attrs"
                                hint="DD/MM/YYYY format"
                                append-icon="mdi-calendar"
                                class="ft-size12 login_text_field br_none"
                                v-model="temporaryAddViewDate2"
                                :error-messages="errors"
                                @click:append="temporaryAddMenu2 = true"
                              ></v-text-field>
                            </ValidationProvider>
                          </template>
                          <v-date-picker v-model="temporaryAddDate2" no-title @input="fnSetTemporaryAddDate2()"></v-date-picker>
                        </v-menu>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="8">
                      <h2 class="nec_title"><i>*</i> {{ $t('application.patent.fields.attach_the_certificate_issued_by_the_temporary_protection') }}</h2>
                      <div class="input_text_type_basic file_type mt-15 fileForm">
                        <ValidationProvider v-slot="{ errors }" :name="$t('application.patent.fields.certification_document_file')" :rules="{required: true}">
                          <v-file-input
                            dense
                            outlined
                            class="ft-size12  login_text_field br_none"
                            :prepend-icon="$t('common.common.select_file')"
                            :placeholder="$t('application.patent.fields.no_files_selected')"
                            v-model="addTemporaryFile"
                            style="height : 40px; max-width:350px;"
                            accept=".pdf, .jpg, .gif"
                            @change="fnChangeTemporaryAddFile()"
                            :error-messages="errors"
                            clearable
                            @click:clear="fnInitTemporaryAddFile()"
                          >
                          </v-file-input>
                        </ValidationProvider>
                      </div>
                    </v-col>
                  </v-row>

                  <v-row class="ma-0">
                    <v-col cols="12" class="pl-0 pr-0 d-flex align-center justify-space-between pop__btn__wrap">
                      <v-btn
                        dense
                        height="50"
                        width="150"
                        outlined
                        rounded
                        color="#a01c2a"
                        class="capitalize btn_basic"
                        @click.stop="fnHideTemporaryAddDialog()"
                      >
                        {{ $t('common.button.cancel') }}
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn
                        dense
                        height="50"
                        width="150"
                        outlined
                        rounded
                        color="#a01c2a"
                        class="capitalize btn_basic"
                        @click.stop="fnTemporaryAddBtn()"
                      >
                        {{ $t('common.button.add') }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </div>
            </v-form>
          </ValidationObserver>
        </v-col>
      </v-row>
    </v-dialog>

    <!-- mod temporary protection -->
    <v-dialog  v-model="temporaryModDialog" flat persistent max-width="900" content-class="br_none">
      <v-card class="br_none modal_comfirm_wrap type4">
        <v-btn class="modal_close" @click="fnHideTemporaryModDialog()" fab color="white">
          <v-icon dark>mdi-close</v-icon>
        </v-btn>
        <h2 class="header_title02 type4">{{ $t('application.patent.fields.mod_temporary_protection') }}</h2>
      </v-card>
      <v-layout class="login_wrap type2 modal_type">
        <v-flex class="pa-0 login_content type2">
          <ValidationObserver ref="modTemporary">
            <v-form
              lazy-validation
            >
              <v-card class="login_form type2 type3" flat>
                <v-card-text class="pa-0 inner_item_content bd_none">
                  <v-row>
                    <v-col cols="12">
                      <h2 class="nec_title"><i>*</i> {{ $t('application.patent.fields.exhibition_name') }}</h2>
                      <div class="input_text_type_basic mt-15">
                        <ValidationProvider v-slot="{ errors }" :name="$t('application.patent.fields.exhibition_name')" :rules="{required: true}">
                          <v-text-field
                            dense
                            outlined
                            clearable
                            maxlength="1024"
                            class="ft-size12 login_text_field"
                            v-model="modTemporary.exhibition_name_en"
                            :error-messages="errors"
                          >
                          </v-text-field>
                        </ValidationProvider>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4">
                      <h2 class="nec_title"><i>*</i> {{ $t('application.patent.fields.country') }}</h2>
                      <div class="input_text_type_basic mt-15">
                        <v-select
                          dense
                          outlined
                          class="ft-size12"
                          :items="($vuetify.rtl) ? countryArList : countryEnList"
                          v-model="modTemporary.exhibition_country_code"
                        >
                        </v-select>
                      </div>
                    </v-col>
                    <v-col cols="4">
                      <h2 class="nec_title"><i>*</i> {{ $t('application.patent.fields.exhibition_opening_date') }}</h2>
                      <div class="input_text_type_basic mt-15">
                        <v-menu
                          ref="temporaryModMenu1"
                          v-model="temporaryModMenu1"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          max-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <ValidationProvider v-slot="{ errors }" :name="$t('application.patent.fields.exhibition_opening_date')" :rules="{required: true}">
                              <v-text-field
                                solo
                                flat
                                dense
                                outlined
                                readonly
                                v-on="on"
                                v-bind="attrs"
                                hint="DD/MM/YYYY format"
                                append-icon="mdi-calendar"
                                class="ft-size12 login_text_field"
                                v-model="temporaryModViewDate1"
                                :error-messages="errors"
                                @click:append="temporaryModMenu1 = true"
                              ></v-text-field>
                            </ValidationProvider>
                          </template>
                          <v-date-picker v-model="temporaryModDate1" no-title @input="fnSetTemporaryModDate1()"></v-date-picker>
                        </v-menu>
                      </div>
                    </v-col>
                    <v-col cols="4">
                      <h2 class="nec_title"><i>*</i> {{ $t('application.patent.fields.date_of_protection') }}</h2>
                      <div class="input_text_type_basic mt-15">
                        <v-menu
                          ref="temporaryModMenu2"
                          v-model="temporaryModMenu2"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          max-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <ValidationProvider v-slot="{ errors }" :name="$t('application.patent.fields.date_of_protection')" :rules="{required: true}">
                              <v-text-field
                                solo
                                flat
                                dense
                                outlined
                                readonly
                                v-on="on"
                                v-bind="attrs"
                                hint="DD/MM/YYYY format"
                                append-icon="mdi-calendar"
                                class="ft-size12 login_text_field"
                                v-model="temporaryModViewDate2"
                                :error-messages="errors"
                                @click:append="temporaryModMenu2 = true"
                              ></v-text-field>
                            </ValidationProvider>
                          </template>
                          <v-date-picker v-model="temporaryModDate2" no-title @input="fnSetTemporaryModDate2()"></v-date-picker>
                        </v-menu>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row class="mt-25">
                    <v-col cols="8">
                      <h2 class="nec_title"><i>*</i> {{ $t('application.patent.fields.attach_the_certificate_issued_by_the_temporary_protection') }}</h2>
                      <div class="input_text_type_basic file_type mt-15 fileForm">
                        <ValidationProvider v-slot="{ errors }" :name="$t('application.patent.fields.certification_document_file')" :rules="{required: fnIsNull(modTemporary.certificate_file_key)}">
                          <v-file-input
                            dense
                            outlined
                            class="ft-size12  login_text_field"
                            :prepend-icon="$t('common.common.select_file')"
                            :placeholder="modTemporaryFileExst && !modTemporaryFileChg ? modTemporary.certificate_file_name : $t('application.patent.fields.no_files_selected')"
                            v-model="modTemporaryFile"
                            style="height : 40px;"
                            accept=".pdf, .jpg, .gif"
                            @change="fnChangeTemporaryModFile()"
                            :error-messages="errors"
                            clearable
                            @click:clear="fnInitTemporaryModFile()"
                            :append-icon="modTemporary.certificate_file_name ? '$clear' : ''"
                            @click:append="fnInitTemporaryModFile()"
                          >
                          </v-file-input>
                        </ValidationProvider>
                      </div>
                    </v-col>
                  </v-row>

                  <v-card-actions class="pl-0 pr-0 mt-25">
                    <v-btn
                      dense
                      height="50"
                      width="150"
                      outlined
                      rounded
                      color="#a01c2a"
                      class="capitalize btn_basic"
                      @click.stop="fnHideTemporaryModDialog()"
                    >
                      {{ $t('common.button.cancel') }}
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                      dense
                      height="50"
                      width="150"
                      dark
                      rounded
                      color="#a01c2a"
                      class="capitalize btn_basic"
                      @click.stop="fnTemporaryModBtn()"
                    >
                      {{ $t('common.button.save') }}
                    </v-btn>
                  </v-card-actions>
                </v-card-text>
              </v-card>
            </v-form>
          </ValidationObserver>
        </v-flex>
      </v-layout>
    </v-dialog>

    <confirm-dialog
      :id="id"
      @deletePriority="fnDeletePriority"
      @deleteTemporary="fnDeleteTemporary"
    />

    <!-- dialog_get_applicants_inventor -->
    <v-dialog
      v-model="dialog_get_applicants_inventor"
      flat
      persistent
      max-width="900"
      content-class="br_none"
    >
      <v-row class="modal__content__wrapper">
        <v-col cols="12" class="pa-0">
          <div class="header__wrap">
            <div>
              <h2 class="modal__title">{{ $t('application.temporaryprotection.fields.get_applicants') }}</h2>
            </div>
            <div class="modal__close__wrap">
              <v-btn @click="dialog_get_applicants_inventor = false"></v-btn>
            </div>
          </div>
        </v-col>
      </v-row>

      <v-layout class="login_wrap type2 modal_type">
        <v-flex class="pa-0 login_content type2">
          <perfect-scrollbar ref="pfscroll" class="h420" style="width: 100%; padding-left: 30px; padding-right: 30px;">
            <v-data-table
              :headers="$getHeaderType1(headerTxt2, headers2)"
              :items="applicants_inventor"
              hide-default-footer
              :items-per-page="5"
              class="new__type__table"
              :mobile-breakpoint="MobileBreakPoint"
              disable-sort
            >
              <template v-slot:item="{ item, index }">
                <tr>
                  <td style="text-align: left;">
                    {{ index + 1 }}
                  </td>
                  <td style="text-align: left;">
                    <p>{{ item.name_ar }}</p>
                    <p>{{ item.name_en }}</p>
                  </td>
                  <td style="text-align: left;">
                    <p>{{ item.address_ar }}</p>
                    <p>{{ item.address_en }}</p>
                  </td>
                  <td>
                      {{ item.applicant_type_code }}
                  </td>
                  <td>
                    {{ item.residence_country_code }}
                  </td>
                  <td>
                    <div class="d-flex">
                      <v-btn
                        color="#a01c2a"
                        dark
                        class="btn-normal br_none ft-size11"
                        @click="fnAddInventorFromApplicant(item.seq)"
                      >
                        {{ $t('common.button.add')}}
                      </v-btn>
                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </perfect-scrollbar>
        </v-flex>
      </v-layout>
    </v-dialog>

    <!-- dialog_get_applicants_representative -->
    <v-dialog
      v-model="dialog_get_applicants_representative"
      flat
      persistent
      max-width="900"
      content-class="br_none"
    >

      <v-row class="modal__content__wrapper">
        <v-col cols="12" class="pa-0">
          <div class="header__wrap">
            <div>
              <h2 class="modal__title">{{ $t('application.temporaryprotection.fields.get_applicants') }}</h2>
            </div>
            <div class="modal__close__wrap">
              <v-btn @click="dialog_get_applicants_representative = false"></v-btn>
            </div>
          </div>
        </v-col>
      </v-row>

      <v-layout class="login_wrap type2 modal_type">
        <v-flex class="pa-0 login_content type2">
          <perfect-scrollbar ref="pfscroll" class="h420" style="width: 100%; padding-left: 30px; padding-right: 30px;">
            <v-data-table
              :headers="$getHeaderType1(headerTxt2, headers2)"
              :items="applicants_representative"
              hide-default-footer
              :items-per-page="5"
              class="new__type__table"
              :mobile-breakpoint="MobileBreakPoint"
              disable-sort
            >
              <template v-slot:item="{ item, index }">
                <tr>
                  <td style="text-align: left;">
                    {{ index + 1 }}
                  </td>
                  <td style="text-align: left;">
                    <p>{{ item.name_ar }}</p>
                    <p>{{ item.name_en }}</p>
                  </td>
                  <td style="text-align: left;">
                    <p>{{ item.address_ar }}</p>
                    <p>{{ item.address_en }}</p>
                  </td>
                  <td>
                      {{ item.applicant_type_code }}
                  </td>
                  <td>
                    {{ item.residence_country_code }}
                  </td>
                  <td>
                    <div class="d-flex">
                      <v-btn
                        color="#a01c2a"
                        dark
                        class="btn-normal br_none ft-size11"
                        @click="fnShowRepresentativeForm(item.seq)"
                      >
                        {{ $t('common.button.add')}}
                      </v-btn>
                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </perfect-scrollbar>
        </v-flex>
      </v-layout>
    </v-dialog>

    <RepresentativeAdd
      :receipt_no.sync="receipt_no"
      :addParams.sync="addParams"
      v-if="dialog_representative_form"
      @success="fnSuccessAddRepresentative"
    />
  </v-container>
</template>
<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import ConfirmDialog from '@/components/layout/ConfirmDialog'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import Applicants from '@/components/layout/Applicants'
import Inventor from '@/components/layout/Inventor'
import Representative from '@/components/layout/Representative'
import RepresentativeAdd from '@/components/layout/RepresentativeAdd'
export default {
  name : 'PatentStep2',
  components :{
    ConfirmDialog,
    ValidationObserver,
    ValidationProvider,
    Applicants,
    Inventor,
    Representative,
    RepresentativeAdd
  },
  data(){
    return {
      MobileBreakPoint : 0,
      id: 'PatentStep2',
      loadingBefore: false,
      loadingNext: false,

      priorityHeaderTxt : {
        prefix : 'application.patent.fields.',
        txt : [ '#', 'filling_date_of_ealier_application','number_of_earlier_application','country','priority_documents','' ]
      },

      priorityHeaders: [
        { text: '#', align: 'center', width:'65'},
        { text: this.$t('application.patent.fields.filling_date_of_ealier_application'), align: 'center' },
        { text: this.$t('application.patent.fields.number_of_earlier_application'), align: 'center' },
        { text: this.$t('application.patent.fields.country'), align: 'center'},
        { text: this.$t('application.patent.fields.priority_documents'), align: 'center', width:250},
        { text: '', align: 'center', width: '95'}
      ],
      priorityList: [],

      temporaryHeaderTxt : {
        prefix : 'application.patent.fields.',
        txt : [ '#', 'country','exhibition_name','exhibition_opening_date','date_of_protection','attachment','' ]
      },

      temporaryHeaders: [
        { text: '#', align: 'center', width:'65'},
        { text: this.$t('application.patent.fields.country'), align: 'center',value: 'country' },
        { text: this.$t('application.patent.fields.exhibition_name'), align: 'center' },
        { text: this.$t('application.patent.fields.exhibition_opening_date'), align: 'center'},
        { text: this.$t('application.patent.fields.date_of_protection'), align: 'center'},
        { text: this.$t('application.patent.fields.attachment'), align: 'center', width:'250'},
        { text: '', align: 'center', width:95}
      ],
      temporaryList: [],

      // priority
      // 모달 컨트롤 객체
      priorityAddDialog : false,
      priorityAddMenu : false,
      priorityAddDate : '',
      priorityAddViewDate : '',
      addPriorityFileAr : null,
      addPriorityFileEn : null,
      // 실제 저장 객체
      addPriority : {
        priority_country_code : '',
        priority_no : '',
        priority_date : '',
        priority_ar_file_key : '',
        priority_en_file_key : ''
      },

      priorityModDialog : false,
      priorityModMenu : false,
      priorityModDate : '',
      priorityModViewDate : '',
      modPriorityFileAr : null,
      modPriorityFileEn : null,
      // 실제 저장 객체
      modPriority : {
        seq : null,
        filing_seq : null,
        //ind_accepted : '',
        priority_country_code : '',
        priority_no : '',
        priority_date : '',
        priority_ar_file_key : '',
        priority_en_file_key : '',
        priority_ar_file_name : '',
        priority_en_file_name : '',
      },

      modPriorFileArExst : false,
      modPriorFileArChg : false,
      modPriorFileEnExst : false,
      modPriorFileEnChg : false,

      // temporary
      // 모달 컨트롤 객체
      temporaryAddDialog : false,

      temporaryAddMenu1 : false,
      temporaryAddMenu2 : false,

      temporaryAddDate1 : '',
      temporaryAddDate2 : '',

      temporaryAddViewDate1 : '',
      temporaryAddViewDate2 : '',

      addTemporaryFile : null,

      // 실제 저장 객체
      addTemporary : {
        exhibition_country_code : '',
        exhibition_name_en : '',
        opening_date : '',
        protection_date : '',
        certificate_file_key : ''
      },

      // 수정 모달
      temporaryModDialog : false,

      temporaryModMenu1 : false,
      temporaryModMenu2 : false,

      temporaryModDate1 : '',
      temporaryModDate2 : '',

      temporaryModViewDate1 : '',
      temporaryModViewDate2 : '',

      modTemporaryFile : null,

      modTemporary : {
        seq : null,
        exhibition_country_code : '',
        exhibition_name_en : '',
        opening_date : '',
        protection_date : '',
        certificate_file_key : ''
      },

      modTemporaryFileExst : false,
      modTemporaryFileChg : false,

      // 국가코드
      countryArList : [],
      countryEnList : [],

      // 컴포넌트 컨트롤 용

      dialog_get_applicants_inventor : false,
      dialog_get_applicants_representative : false,
      dialog_representative_form : false,
      isNewable: true,

      headerTxt2 : {
        prefix : 'application.patent.fields.',
        txt : [ '#', 'name','address','applicant_type','residence', '' ]
      },

      headers2: [
        { text: '#', align: 'left', width: '50px'},
        { text: 'Name', align: 'left', width:'180px' },
        { text: 'Address', align: 'left' },
        { text: 'Applicant Type', align: 'right', width: '125px' },
        { text: 'Residence',  align: 'center', width: '98px' },
        { text: '',  align: 'center', width: '100px' }
      ],

      applicants: [],
      applicants_inventor: [],
      applicants_representative: [],

      receipt_no : '',

      auto_insert_applicant : false,
      auto_insert_representative : false,

      seq : 0,
      flag_applicant : false,
      flag_inventor : false,
      flag_representative : false,

      userInfo : {
        seq : '',
        company_seq : '',
        email : '',
        lasted_login_date : '',
        login_failed_count : '',
        account_lock_date : '',
        user_status_type_code : '',
        name_ar : '',
        name_en : '',
        personal_identify_no : '',
        valid_until_date : '',
        strong_auth_type_code : '',
        user_group_type_code : '',
        user_type_code : '',
        agent_no : '',
        birthday_date : '',
        gender_type_code : '',
        id_card_file_key : '',
        id_card_file_name: '',
        student_id_file_key: '',
        student_id_file_name: '',
        address_ar : '',
        address_en : '',
        city_name_ar : '',
        city_name_en : '',
        residence_country_code : '',
        pobox : '',
        postal : '',
        nationality_code : '',
        telephone : '',
        mobile : '',
        fax : '',
        avatar_file_key : '',
        sign_image : '',
        ind_representative : '',
        agent_authorization_type_code : '',
        ind_active : ''
      },

      company : {
        seq : '',
        company_type_code : '',
        company_regiration_no : '',
        name_ar : '',
        name_en : '',
        address_ar : '',
        address_en : '',
        city_name_ar : '',
        city_name_en : '',
        residence_country_code : '',
        residence_country_name_ar : '',
        residence_country_name_en : '',
        pobox : '',
        postal : '',
        registry_cert_file_key : '',
        registry_cert_file_name : '',
        registry_cert_file_ext : '',
        company_status_type_code : '',
        telephone : '',
        mobile : '',
        fax : '',
        representative_email : ''
      },

      addParams : {
        nationality_code : '',
        name_ar : '',
        name_en : '',
        address_ar : '',
        address_en : '',
        pobox_ar : '',
        pobox_en : '',
        birthday_date : '',
        gender_type_code : '',
        telephone : '',
        mobile : '',
        fax : '',
        email : '',
        agent_no : '',
        rep_scope_type_code : '',
        poa_upload_type_code : '',
        poa_reference_app_no : '',
        poa_file_key : '',
        applicants : []
      }
    }
  },
  mounted(){
    window.scrollTo(0, 0)
    this.receipt_no = this.$route.params.receipt_no
    this.fnGetReceipt()
    this.fnInit()
  },
  methods: {
    fnInit(){
      this.fnGetUserInfo()
      this.fnGetCountryList()
      this.fnGetPriorityList()
      this.fnGetTemporaryList()
    },
    fnGetReceipt(){
      requestApi({
        url: '/receivings/' + this.receipt_no,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            // draft 상태가 아니면 My Request 페이지로 이동
            if (res.data.service_type_code !== '6402'
              || res.data.receipt_status_type_code !== '4301'
              || res.data.receipt_step < 2) {
              this.$router.push('/myrequest/list')
            }
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetReceipt()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    // 컴포넌트용
    fnGetUserInfo(){
      //사용자정보 조회
      requestApi({
        url: '/users/profile',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {

            this.userInfo.seq = res.data.seq
            this.userInfo.company_seq = res.data.company_seq
            this.userInfo.email = res.data.email
            this.userInfo.lasted_login_date = res.data.lasted_login_date
            this.userInfo.login_failed_count = res.data.login_failed_count
            this.userInfo.account_lock_date = res.data.account_lock_date
            this.userInfo.user_status_type_code = res.data.user_status_type_code
            this.userInfo.name_ar = res.data.name_ar
            this.userInfo.name_en = res.data.name_en
            this.userInfo.personal_identify_no = res.data.personal_identify_no
            this.userInfo.valid_until_date = res.data.valid_until_date
            this.userInfo.strong_auth_type_code = res.data.strong_auth_type_code
            this.userInfo.user_group_type_code = res.data.user_group_type_code
            this.userInfo.user_type_code = res.data.user_type_code
            this.userInfo.agent_no = res.data.agent_no
            this.userInfo.birthday_date = res.data.birthday_date
            this.userInfo.gender_type_code = res.data.gender_type_code
            this.userInfo.id_card_file_key = res.data.id_card_file_key
            this.userInfo.id_card_file_name = res.data.id_card_file_name
            this.userInfo.student_id_file_key = res.data.student_id_file_key
            this.userInfo.student_id_file_name = res.data.student_id_file_name
            this.userInfo.address_ar = res.data.address_ar
            this.userInfo.address_en = res.data.address_en
            this.userInfo.city_name_ar = res.data.city_name_ar
            this.userInfo.city_name_en = res.data.city_name_en
            this.userInfo.residence_country_code = res.data.residence_country_code
            this.userInfo.pobox = res.data.pobox
            this.userInfo.postal = res.data.postal
            this.userInfo.nationality_code = res.data.nationality_code
            this.userInfo.telephone = res.data.telephone
            this.userInfo.mobile = res.data.mobile
            this.userInfo.fax = res.data.fax
            this.userInfo.avatar_file_key = res.data.avatar_file_key
            this.userInfo.sign_image = res.data.sign_image
            this.userInfo.ind_representative = res.data.ind_representative
            this.userInfo.agent_authorization_type_code = res.data.agent_authorization_type_code
            this.userInfo.ind_active = res.data.ind_active

            if(res.data.user_type_code != '2704' && res.data.user_type_code != '2705' ){
              //개인 사용자가 아니라면(company거나 agent) 회사 정보도 가져온다
              requestApi({
                url: '/users/company/information',
                method: 'GET',
                callback: (res) => {
                  if (res.res_code === '200') {
                    this.company.seq = res.data.seq
                    this.company.company_type_code = res.data.company_type_code
                    this.company.company_regiration_no = res.data.company_regiration_no
                    this.company.name_ar = res.data.name_ar
                    this.company.name_en = res.data.name_en
                    this.company.address_ar = res.data.address_ar
                    this.company.address_en = res.data.address_en
                    this.company.city_name_ar = res.data.city_name_ar
                    this.company.city_name_en = res.data.city_name_en
                    this.company.residence_country_code = res.data.residence_country_code
                    this.company.residence_country_name_ar = res.data.residence_country_name_ar
                    this.company.residence_country_name_en = res.data.residence_country_name_en
                    this.company.pobox = res.data.pobox
                    this.company.postal = res.data.postal
                    this.company.registry_cert_file_key = res.data.registry_cert_file_key
                    this.company.registry_cert_file_name = res.data.registry_cert_file_name
                    this.company.registry_cert_file_ext = res.data.registry_cert_file_ext
                    this.company.company_status_type_code = res.data.company_status_type_code
                    this.company.telephone = res.data.telephone
                    this.company.mobile = res.data.mobile
                    this.company.fax = res.data.fax
                    this.company.representative_email = res.data.representative_email

                    //Temporary Application Application 조회
                    this.fnGetTemporaryApplication()

                  }else{
                    if (res.res_code === '401012') {
                      utils.setTokenRefresh().then(() => {
                        this.fnGetUserInfo()
                      })
                    } else {
                      eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                    }
                  }
                }
              })
            }else{
              //Temporary Application Application 조회
              this.fnGetTemporaryApplication()
            }
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetUserInfo()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    //Temporary Application Application 조회
    fnGetTemporaryApplication(){
      //사용자정보 조회 후 사용자 구분에 따라 applicant와 representative의 최초 자동인서트 여부를 결정한다
      if(this.userInfo.user_group_type_code == '3801' || this.userInfo.user_group_type_code == '3802'){
        //개인회원 이거나 COMPANY회원 이라면
        this.auto_insert_applicant = true
        this.auto_insert_representative = true
      }

      if(this.userInfo.user_group_type_code == '3803' || this.userInfo.user_group_type_code == '3804'){
        //AGENT라면
        this.auto_insert_applicant = false
        this.auto_insert_representative = true
      }

      this.flag_applicant = true
      this.flag_inventor = true
      this.flag_representative = true
    },
    fnRefreshComponent(){
      this.$refs.component_applicants.fnGetApplicants()
      this.$refs.component_inventors.fnGetInventors()
      this.$refs.component_representative.fnGetRepresentatives()
    },
    fnSuccessAddRepresentative(){
      this.dialog_representative_form = false
      this.$refs.component_representative.fnSuccess()
    },

    getApplicantForInventor(){

      requestApi({
        url: '/receivings/'+this.receipt_no+'/applicants',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.applicants_inventor = []

            //타입이 Company이거나 SmallCompany가 아닌 Applicants
            let applicantList = []
            for(let k=0; k<res.data.list.length; k++){
              if(res.data.list[k].applicant_type_code != '2701' && res.data.list[k].applicant_type_code != '2702'){
                applicantList.push(res.data.list[k])
              }
            }

            //inventor 리스트를 구해온다.
            requestApi({
              url: '/receivings/'+this.receipt_no+'/inventors',
              method: 'GET',
              callback: (res) => {
                if(res.res_code === '200'){

                  let inventorList = res.data.list

                  for(let i=0; i<applicantList.length; i++){

                    let flag = true

                    for(let k=0; k<inventorList.length; k++){
                      if(applicantList[i].seq == inventorList[k].applicant_seq){
                        flag = false
                      }
                    }

                    if(flag){
                      this.applicants_inventor.push(applicantList[i])
                    }
                  }

                }else{
                  if (res.res_code === '401012') {
                    utils.setTokenRefresh().then(() => {
                      this.getApplicantForInventor()
                    })
                  } else {
                    eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                  }
                }
              }
            })

          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.getApplicantForInventor()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
      this.dialog_get_applicants_inventor = true
    },

    fnAddInventorFromApplicant(seq){
      requestApi({
        url: '/receivings/'+this.receipt_no+'/applicants/'+seq,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            let params = {
              nationality_code : res.data.nationality_code,
              residence_country_code : res.data.residence_country_code,
              name_ar : res.data.name_ar,
              name_en : res.data.name_en,
              address_ar : res.data.address_ar,
              address_en : res.data.address_en,
              pobox_ar : res.data.pobox_ar,
              pobox_en : res.data.pobox_en,
              birthday_date : res.data.birthday_date,
              gender_type_code : res.data.gender_type_code,
              telephone : res.data.telephone,
              mobile : res.data.mobile,
              fax : res.data.fax,
              email : res.data.email,
              applicant_seq : res.data.seq
            }

            requestApi({
              url: '/receivings/'+this.receipt_no+'/inventors',
              method: 'POST',
              data: params,
              callback: (res) => {
                if (res.res_code === '200') {
                  //등록 하고 나서 컴포넌트의 석세스함수를 호출
                  this.$refs.component_inventors.fnSuccess()
                  this.dialog_get_applicants_inventor = false
                }
              }
            })
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnAddInventorFromApplicant(seq)
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    getApplicantForRepresentative(){
      requestApi({
        url: '/receivings/'+this.receipt_no+'/applicants',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            //this.applicants_representative = res.data.list
            this.applicants_representative = []

            let all_applicants = res.data.list

            requestApi({
              url: '/receivings/'+this.receipt_no+'/representatives',
              method: 'GET',
              callback: (res) => {
                if (res.res_code === '200') {
                  let used_applicants = []
                  let flag_all = false

                  for(let i=0; i<res.data.list.length; i++){
                    if(res.data.list[i].rep_scope_type_code == '5101'){
                      flag_all = true
                    }else{
                      for(let k=0; k<res.data.list[i].applicants.length; k++){
                        used_applicants.push(res.data.list[i].applicants[k])
                      }
                    }
                  }

                  if(flag_all){
                    this.applicants_representative = []
                  }else{
                    for(let i=0; i<all_applicants.length; i++){
                      let flag_used = false

                      for(let k=0; k<used_applicants.length; k++){
                        if(all_applicants[i].seq == used_applicants[k].seq ){
                          flag_used = true
                        }
                      }

                      if(flag_used){
                        this.applicants_representative.push(all_applicants[i])
                      }
                    }
                  }

                }else{
                  if (res.res_code === '401012') {
                    utils.setTokenRefresh().then(() => {
                      this.getApplicantForRepresentative()
                    })
                  } else {
                    eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                  }
                }
              }
            })

          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.getApplicantForRepresentative()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })

      this.dialog_get_applicants_representative = true
    },

    fnShowRepresentativeForm(seq){
      requestApi({
        url: '/receivings/'+this.receipt_no+'/applicants/'+seq,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {

            this.addParams.nationality_code = res.data.nationality_code
            this.addParams.residence_country_code = res.data.residence_country_code
            this.addParams.name_ar = res.data.name_ar
            this.addParams.name_en = res.data.name_en
            this.addParams.address_ar = res.data.address_ar
            this.addParams.address_en = res.data.address_en
            this.addParams.pobox_ar = res.data.pobox_ar
            this.addParams.pobox_en = res.data.pobox_en
            this.addParams.birthday_date = res.data.birthday_date
            this.addParams.gender_type_code = res.data.gender_type_code
            this.addParams.telephone = res.data.telephone
            this.addParams.mobile = res.data.mobile
            this.addParams.fax = res.data.fax
            this.addParams.email = res.data.email
            this.addParams.agent_no = res.data.agent_no
            this.addParams.rep_scope_type_code = '5101'

            this.dialog_get_applicants_representative = false
            this.dialog_representative_form = true
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnShowRepresentativeForm(seq)
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnSetRepresentativeNewable(isNewable){
      this.isNewable = isNewable
    },


    fnGetCountryList(){
      utils.fnGetCountryList('en').then(list => {
        this.countryEnList = list
      }).catch((res)=>{
        eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
      })

      utils.fnGetCountryList('ar').then(list => {
        this.countryArList = list
      }).catch((res)=>{
        eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
      })
    },
    fnGetPriorityList(){
      requestApi({
        url: '/receivings/' + this.$route.params.receipt_no + '/priorities',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.priorityList = res.data.list
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetPriorityList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetTemporaryList(){
      requestApi({
        url: '/receivings/' + this.$route.params.receipt_no + '/temporaries',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.temporaryList = res.data.list
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetTemporaryList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnShowPriorityAddDialog(){
      this.priorityAddDialog = true
      // 입력 폼 초기화
      this.fnInitPriorityAdd()
      requestAnimationFrame(() => {
        this.$refs.addPriority.reset()
      })
    },
    fnHidePriorityAddDialog(){
      // 입력 폼 초기화
      this.fnInitPriorityAdd()
      requestAnimationFrame(() => {
        this.$refs.addPriority.reset()
      })
      this.priorityAddDialog = false
    },
    fnSetPriorityAddDate(){
      this.priorityAddViewDate = this.formatViewDate(this.priorityAddDate)
      this.priorityAddMenu = false
      this.addPriority.priority_date = this.formatDate(this.priorityAddDate)
    },
    fnInitPriorityAdd(){
      this.addPriority.priority_country_code = 'EG'
      this.addPriority.priority_date = ''
      this.addPriority.priority_ar_file_key = ''
      this.addPriority.priority_en_file_key = ''
      this.addPriority.priority_no = ''

      this.priorityAddDate = ''
      this.priorityAddViewDate = ''
      this.addPriorityFileAr = null
      this.addPriorityFileEn = null
    },
    fnInitPriorityAr() {
      this.addPriorityFileAr = null
      this.addPriority.priority_ar_file_key = ''
      this.addPriority.priority_ar_file_name = ''
    },
    fnChangePriorityAddFileAr(){
      if(!utils.isNull(this.addPriorityFileAr)){
        let extList = []
        extList.push({name_en: 'pdf'})
        extList.push({name_en: 'jpg'})
        extList.push({name_en: 'gif'})

        if (utils.getFileExtLen(this.addPriorityFileAr, extList, this.$t('common.message.file_extension_error')) === -1) {
          setTimeout(() => {
            this.addPriorityFileAr = null
            this.addPriority.priority_ar_file_key = ''
            this.addPriority.priority_ar_file_name = ''
          }, 100)

          return
        }

        // 업로드 후 저장객체에 파일키 세팅
        let formData = new FormData()
        formData.append("file_data", this.addPriorityFileAr)

        requestApi({
          url: '/file/documents/upload',
          method: 'POST',
          data: formData,
          headers : {"Content-Type":"multipart/form-data"},
          callback: (res) => {
            // 파일저장
            if (res.res_code === '200') {
              this.addPriority.priority_ar_file_key = res.data.file_key
            }else{
              if (res.res_code === '401012') {
                utils.setTokenRefresh().then(() => {
                  this.fnChangePriorityAddFileAr()
                })
              } else {
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                this.addPriorityFileAr = null
                this.addPriority.priority_ar_file_key = ''
                this.addPriority.priority_ar_file_name = ''
              }
            }
          }
        })
      }
    },
    fnInitPriorityEn() {
      this.addPriorityFileEn = null
      this.addPriority.priority_en_file_key = ''
      this.addPriority.priority_en_file_name = ''
    },
    fnChangePriorityAddFileEn(){
      if(!utils.isNull(this.addPriorityFileEn)){
        let extList = []
        extList.push({name_en: 'pdf'})
        extList.push({name_en: 'jpg'})
        extList.push({name_en: 'gif'})

        if (utils.getFileExtLen(this.addPriorityFileEn, extList, this.$t('common.message.file_extension_error')) === -1) {
          setTimeout(() => {
            this.addPriorityFileEn = null
            this.addPriority.priority_en_file_key = ''
            this.addPriority.priority_en_file_name = ''
          }, 100)

          return
        }

        // 업로드 후 저장객체에 파일키 세팅
        let formData = new FormData()
        formData.append("file_data", this.addPriorityFileEn)

        requestApi({
          url: '/file/documents/upload',
          method: 'POST',
          data: formData,
          headers : {"Content-Type":"multipart/form-data"},
          callback: (res) => {
            // 파일저장
            if (res.res_code === '200') {
              this.addPriority.priority_en_file_key = res.data.file_key
            }else{
              if (res.res_code === '401012') {
                utils.setTokenRefresh().then(() => {
                  this.fnChangePriorityAddFileEn()
                })
              } else {
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                this.addPriorityFileEn = null
                this.addPriority.priority_en_file_key = ''
                this.addPriority.priority_en_file_name = ''
              }
            }
          }
        })
      }
    },
    fnPriorityAddBtn(){

      if(!utils.isNull(this.priorityList.find( item => item.priority_no == this.addPriority.priority_no))){
        let snackBarOptions = {
          text: this.$t('application.patent.fields.used_number')
        }
        eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)
        this.$nextTick(this.$refs.add_priority_no.focus)
        return
      }

      //벨리데이션 체크 후 저장
      this.$refs.addPriority.validate().then((valid) => {
        if(valid){
          requestApi({
            url: '/receivings/' + this.$route.params.receipt_no + '/priorities',
            method: 'POST',
            data: this.addPriority,
            callback: (res) => {
              if (res.res_code === '200') {
                let snackBarOptions = {
                  text: this.$t('common.message.add.success')
                }
                eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)
                this.fnHidePriorityAddDialog()
                this.fnGetPriorityList()
              }else{
                if (res.res_code === '401012') {
                  utils.setTokenRefresh().then(() => {
                    this.fnPriorityAddBtn()
                  })
                } else {
                  eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                }
              }
            }
          })
        } else {
          //2020-11-03 : 첫번째 에러 항목으로 Focus 되도록 추가 수정 (vee-validate 3.0 기반)
          document.getElementsByClassName('error--text')[0].scrollIntoView(false)
        }
      })
    },
    fnShowPriorityModDialog(seq){
      requestApi({
        url: '/receivings/' + this.$route.params.receipt_no + '/priorities/' + seq,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {

            this.fnInitPriorityMod()

            this.modPriority.seq = res.data.seq
            //this.modPriority.filing_seq = res.data.filing_seq
            this.modPriority.priority_country_code = res.data.priority_country_code
            this.modPriority.priority_no = res.data.priority_no
            this.modPriority.priority_date = res.data.priority_date
            //this.modPriority.ind_accepted = res.data.ind_accepted
            this.modPriority.priority_ar_file_key = res.data.priority_ar_file_key
            this.modPriority.priority_ar_file_name = res.data.priority_ar_file_name
            this.modPriority.priority_en_file_key = res.data.priority_en_file_key
            this.modPriority.priority_en_file_name = res.data.priority_en_file_name

            this.modPriorFileArExst = !utils.isNull(res.data.priority_ar_file_key)
            this.modPriorFileEnExst = !utils.isNull(res.data.priority_en_file_key)

            this.priorityModDate =  this.formatDate2(res.data.priority_date)
            this.priorityModViewDate = this.convertDateForm(res.data.priority_date)

            this.priorityModDialog = true
            requestAnimationFrame(() => {
              this.$refs.modPriority.reset()
            })
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnShowPriorityModDialog(seq)
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnHidePriorityModDialog(){
      // 입력 폼 초기화
      this.fnInitPriorityMod()
      requestAnimationFrame(() => {
        this.$refs.modPriority.reset()
      })
      this.priorityModDialog = false
    },
    fnSetPriorityModDate(){
      this.priorityModViewDate = this.formatViewDate(this.priorityModDate)
      this.priorityModMenu = false
      this.modPriority.priority_date = this.formatDate(this.priorityModDate)
    },
    fnInitPriorityMod(){
      this.modPriority.priority_country_code = ''
      this.modPriority.priority_date = ''
      this.modPriority.priority_ar_file_key = ''
      this.modPriority.priority_ar_file_name = ''
      this.modPriority.priority_en_file_key = ''
      this.modPriority.priority_en_file_name = ''
      this.modPriority.priority_no = ''
      this.modPriority.seq = null
      this.modPriority.filing_seq = null
      this.modPriority.ind_accepted = ''

      this.priorityModDate = ''
      this.priorityModViewDate = ''
      this.modPriorityFileAr = null
      this.modPriorityFileEn = null

      this.modPriorFileEnExst = false
      this.modPriorFileEnChg = false
      this.modPriorFileArExst = false
      this.modPriorFileArChg = false
    },
    fnInitPriorityModAr() {
      this.modPriorityFileAr = null
      this.modPriority.priority_ar_file_key = ''
      this.modPriority.priority_ar_file_name = ''
    },
    fnChangePriorityModFileAr(){
      if(!utils.isNull(this.modPriorityFileAr)){
        let extList = []
        extList.push({name_en: 'pdf'})
        extList.push({name_en: 'jpg'})
        extList.push({name_en: 'gif'})

        if (utils.getFileExtLen(this.modPriorityFileAr, extList, this.$t('common.message.file_extension_error')) === -1) {
          setTimeout(() => {
            this.modPriorityFileAr = null
            this.modPriority.priority_ar_file_key = ''
            this.modPriority.priority_ar_file_name = ''
          }, 100)

          return
        }

        // 업로드 후 저장객체에 파일키 세팅
        let formData = new FormData()
        formData.append("file_data", this.modPriorityFileAr)

        requestApi({
          url: '/file/documents/upload',
          method: 'POST',
          data: formData,
          headers : {"Content-Type":"multipart/form-data"},
          callback: (res) => {
            // 파일저장
            if (res.res_code === '200') {
              this.modPriority.priority_ar_file_key = res.data.file_key
              this.modPriorFileArChg = true
            }else{
              if (res.res_code === '401012') {
                utils.setTokenRefresh().then(() => {
                  this.fnChangePriorityAddFileAr()
                })
              } else {
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                this.modPriorityFileAr = null
                this.modPriority.priority_ar_file_key = ''
                this.modPriority.priority_ar_file_name = ''
              }
            }
          }
        })
      }
    },
    fnInitPriorityModEn() {
      this.modPriorityFileEn = null
      this.modPriority.priority_en_file_key = ''
      this.modPriority.priority_en_file_name = ''
    },
    fnChangePriorityModFileEn(){
      if(!utils.isNull(this.modPriorityFileEn)){
        let extList = []
        extList.push({name_en: 'pdf'})
        extList.push({name_en: 'jpg'})
        extList.push({name_en: 'gif'})

        if (utils.getFileExtLen(this.modPriorityFileEn, extList, this.$t('common.message.file_extension_error')) === -1) {
          setTimeout(() => {
            this.modPriorityFileEn = null
            this.modPriority.priority_en_file_key = ''
            this.modPriority.priority_en_file_name = ''
          }, 100)

          return
        }
        // 업로드 후 저장객체에 파일키 세팅
        let formData = new FormData()
        formData.append("file_data", this.modPriorityFileEn)

        requestApi({
          url: '/file/documents/upload',
          method: 'POST',
          data: formData,
          headers : {"Content-Type":"multipart/form-data"},
          callback: (res) => {
            // 파일저장
            if (res.res_code === '200') {
              this.modPriority.priority_en_file_key = res.data.file_key
              this.modPriorFileEnChg = true
            }else{
              if (res.res_code === '401012') {
                utils.setTokenRefresh().then(() => {
                  this.fnChangePriorityAddFileEn()
                })
              } else {
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                this.modPriorityFileEn = null
                this.modPriority.priority_en_file_key = ''
                this.modPriority.priority_en_file_name = ''
              }
            }
          }
        })
      }
    },
    fnPriorityModBtn(){
      if(!utils.isNull(this.priorityList.find( item => item.priority_no == this.modPriority.priority_no && item.seq != this.modPriority.seq ))){
        let snackBarOptions = {
          text: this.$t('application.patent.fields.used_number')
        }
        eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)
        this.$nextTick(this.$refs.mod_priority_no.focus)
        return
      }

      this.$refs.modPriority.validate().then((valid) => {

        if(valid){
          let params = {
            priority_country_code : this.modPriority.priority_country_code,
            priority_ar_file_key : this.modPriority.priority_ar_file_key,
            priority_en_file_key : this.modPriority.priority_en_file_key,
            priority_date : this.modPriority.priority_date,
            priority_no : this.modPriority.priority_no
          }

          requestApi({
            url: '/receivings/' + this.$route.params.receipt_no + '/priorities/' + this.modPriority.seq,
            method: 'PUT',
            data: params,
            callback: (res) => {
              if (res.res_code === '200') {
                let snackBarOptions = {
                  text: this.$t('common.message.modify.success')
                }
                eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)

                this.fnHidePriorityModDialog()
                this.fnGetPriorityList()
              }else{
                if (res.res_code === '401012') {
                  utils.setTokenRefresh().then(() => {
                    this.fnPriorityModBtn()
                  })
                } else {
                  eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                }
              }
            }
          })
        } else {
          //2020-11-03 : 첫번째 에러 항목으로 Focus 되도록 추가 수정 (vee-validate 3.0 기반)
          document.getElementsByClassName('error--text')[0].scrollIntoView(false)
        }

      })
    },
    fnPriorityDeleteConfirm(seq){
      let options = {
        title: this.$t('common.message.delete.confirm.title'),
        text: this.$t('common.message.delete.confirm.text'),
        yes: {
          text: this.$t('common.button.yes'),
          event: 'deletePriority',
          callback: {
            seq: seq
          }
        },
        no: {
          text: this.$t('common.button.no')
        }
      }
      eventBus.$emit('SHOW_CONFIRM_DIALOG'+ this.id, options)
    },
    fnDeletePriority(obj){
      requestApi({
        url: '/receivings/' + this.$route.params.receipt_no + '/priorities/' + obj.seq,
        method: 'DELETE',
        callback: (res) => {
          if (res.res_code === '200') {
            eventBus.$emit('CLOSE_CONFIRM_DIALOG'+ this.id)
            let snackBarOptions = {
              text: this.$t('common.message.delete.success')
            }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)
            this.fnGetPriorityList()
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnDeletePriority(obj)
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnShowTemporaryAddDialog(){
      this.temporaryAddDialog = true
      // 입력 폼 초기화
      this.fnInitTemporaryAdd()
      requestAnimationFrame(() => {
        this.$refs.addTemporary.reset()
      })
    },
    fnHideTemporaryAddDialog(){
      // 입력 폼 초기화
      this.fnInitTemporaryAdd()
      requestAnimationFrame(() => {
        this.$refs.addTemporary.reset()
      })
      this.temporaryAddDialog = false
    },
    fnInitTemporaryAdd(){
      this.addTemporary.exhibition_country_code = 'EG'
      this.addTemporary.exhibition_name_en = ''
      this.addTemporary.opening_date = ''
      this.addTemporary.protection_date = ''
      this.addTemporary.certificate_file_key = ''

      this.temporaryAddDate1 = ''
      this.temporaryAddDate2 = ''
      this.temporaryAddViewDate1 = ''
      this.temporaryAddViewDate2 = ''
      this.addTemporaryFile = null
    },
    fnSetTemporaryAddDate1(){
      this.temporaryAddViewDate1 = this.formatViewDate(this.temporaryAddDate1)
      this.temporaryAddMenu1 = false
      // 저장객체에 날짜 세팅
      this.addTemporary.opening_date = this.formatDate(this.temporaryAddDate1)
    },
    fnSetTemporaryAddDate2(){
      this.temporaryAddViewDate2 = this.formatViewDate(this.temporaryAddDate2)
      this.temporaryAddMenu2 = false
      // 저장객체에 날짜 세팅
      this.addTemporary.protection_date = this.formatDate(this.temporaryAddDate2)
    },
    fnInitTemporaryAddFile() {
      // 저장 객체 파일키 제거
      this.addTemporaryFile = null
      this.addTemporary.certificate_file_key = ''
      this.addTemporary.certificate_file_name = ''
    },
    fnChangeTemporaryAddFile(){
      if(!utils.isNull(this.addTemporaryFile)){
        let extList = []
        extList.push({name_en: 'pdf'})
        extList.push({name_en: 'jpg'})
        extList.push({name_en: 'gif'})

        if (utils.getFileExtLen(this.addTemporaryFile, extList, this.$t('common.message.file_extension_error')) === -1) {
          setTimeout(() => {
            this.addTemporaryFile = null
            this.addTemporary.certificate_file_key = ''
            this.addTemporary.certificate_file_name = ''
          }, 100)

          return
        }

        // 업로드 후 저장객체에 파일키 세팅
        let formData = new FormData()
        formData.append("file_data", this.addTemporaryFile)

        requestApi({
          url: '/file/documents/upload',
          method: 'POST',
          data: formData,
          headers : {"Content-Type":"multipart/form-data"},
          callback: (res) => {
            // 파일저장
            if (res.res_code === '200') {
              this.addTemporary.certificate_file_key = res.data.file_key
            }else{
              if (res.res_code === '401012') {
                utils.setTokenRefresh().then(() => {
                  this.fnChangeTemporaryAddFile()
                })
              } else {
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                this.addTemporaryFile = null
                this.addTemporary.certificate_file_key = ''
                this.addTemporary.certificate_file_name = ''
              }
            }
          }
        })
      }
    },
    fnTemporaryAddBtn(){
      //벨리데이션 체크 후 저장
      this.$refs.addTemporary.validate().then((valid) => {
        if(valid){
          requestApi({
            url: '/receivings/' + this.$route.params.receipt_no + '/temporary',
            method: 'POST',
            data: this.addTemporary,
            callback: (res) => {
              if (res.res_code === '200') {
                let snackBarOptions = {
                  text: this.$t('common.message.add.success')
                }
                eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)
                this.fnHideTemporaryAddDialog()
                this.fnGetTemporaryList()
              }else{
                if (res.res_code === '401012') {
                  utils.setTokenRefresh().then(() => {
                    this.fnTemporaryAddBtn()
                  })
                } else {
                  eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                }
              }
            }
          })
        } else {
          //2020-11-03 : 첫번째 에러 항목으로 Focus 되도록 추가 수정 (vee-validate 3.0 기반)
          document.getElementsByClassName('error--text')[0].scrollIntoView(false)
        }
      })
    },
    fnShowTemporaryModDialog(seq){
      requestApi({
        url: '/receivings/' + this.$route.params.receipt_no + '/temporary/' + seq,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {

            this.fnInitTemporaryMod()

            this.modTemporary.seq = res.data.seq
            this.modTemporary.filing_seq = res.data.filing_seq
            this.modTemporary.exhibition_country_code = res.data.exhibition_country_code
            this.modTemporary.exhibition_name_en = res.data.exhibition_name_en
            this.modTemporary.opening_date = res.data.opening_date
            this.modTemporary.protection_date = res.data.protection_date
            this.modTemporary.certificate_file_key = res.data.certificate_file_key
            this.modTemporary.certificate_file_name = res.data.certificate_file_name

            this.modTemporaryFileExst = !utils.isNull(res.data.certificate_file_key)

            this.temporaryModDate1 =  this.formatDate2(res.data.opening_date)
            this.temporaryModDate2 =  this.formatDate2(res.data.protection_date)

            this.temporaryModViewDate1 =  this.convertDateForm(res.data.opening_date)
            this.temporaryModViewDate2 =  this.convertDateForm(res.data.protection_date)

            this.temporaryModDialog = true
            requestAnimationFrame(() => {
              this.$refs.modTemporary.reset()
            })
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnShowTemporaryModDialog(seq)
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnHideTemporaryModDialog(){
      // 입력 폼 초기화
      this.fnInitTemporaryMod()
      requestAnimationFrame(() => {
        this.$refs.modTemporary.reset()
      })
      this.temporaryModDialog = false
    },
    fnSetTemporaryModDate1(){
      this.temporaryModViewDate1 = this.formatViewDate(this.temporaryModDate1)
      this.temporaryModMenu1 = false
      this.modTemporary.opening_date = this.formatDate(this.temporaryModDate1)
    },
    fnSetTemporaryModDate2(){
      this.temporaryModViewDate2 = this.formatViewDate(this.temporaryModDate2)
      this.temporaryModMenu2 = false
      this.modTemporary.protection_date = this.formatDate(this.temporaryModDate2)
    },
    fnInitTemporaryMod(){

      this.temporaryModDate1 = ''
      this.temporaryModDate2 = ''
      this.temporaryModViewDate1 = ''
      this.temporaryModViewDate2 = ''

      this.modTemporaryFile = null

      this.modTemporary.seq = null
      this.modTemporary.exhibition_country_code = ''
      this.modTemporary.exhibition_name_en = ''
      this.modTemporary.opening_date = ''
      this.modTemporary.protection_date = ''
      this.modTemporary.certificate_file_key = ''

      this.modTemporaryFileExst = false
      this.modTemporaryFileChg = false
    },
    fnInitTemporaryModFile() {
      this.modTemporaryFile = null
      this.modTemporary.certificate_file_key = ''
      this.modTemporary.certificate_file_name = ''
    },
    fnChangeTemporaryModFile(){
      if(!utils.isNull(this.modTemporaryFile)){
        let extList = []
        extList.push({name_en: 'pdf'})
        extList.push({name_en: 'jpg'})
        extList.push({name_en: 'gif'})

        if (utils.getFileExtLen(this.modTemporaryFile, extList, this.$t('common.message.file_extension_error')) === -1) {
          setTimeout(() => {
            this.modTemporaryFile = null
            this.modTemporary.certificate_file_key = ''
            this.modTemporary.certificate_file_name = ''
          }, 100)

          return
        }

        // 업로드 후 저장객체에 파일키 세팅
        let formData = new FormData()
        formData.append("file_data", this.modTemporaryFile)

        requestApi({
          url: '/file/documents/upload',
          method: 'POST',
          data: formData,
          headers : {"Content-Type":"multipart/form-data"},
          callback: (res) => {
            // 파일저장
            if (res.res_code === '200') {
              this.modTemporary.certificate_file_key = res.data.file_key
              this.modTemporaryFileChg = true
            }else{
              if (res.res_code === '401012') {
                utils.setTokenRefresh().then(() => {
                  this.fnChangeTemporaryModFile()
                })
              } else {
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                this.modTemporaryFile = null
                this.modTemporary.certificate_file_key = ''
                this.modTemporary.certificate_file_name = ''
              }
            }
          }
        })
      }
    },
    fnTemporaryModBtn(){
      //벨리데이션 체크 후 저장
      this.$refs.modTemporary.validate().then((valid) => {
        if(valid){
          let params = {
            exhibition_country_code : this.modTemporary.exhibition_country_code,
            protection_date : this.modTemporary.protection_date,
            certificate_file_key : this.modTemporary.certificate_file_key,
            opening_date : this.modTemporary.opening_date,
            exhibition_name_en : this.modTemporary.exhibition_name_en
          }

          requestApi({
            url: '/receivings/' + this.$route.params.receipt_no + '/temporary/' + this.modTemporary.seq,
            method: 'PUT',
            data: params,
            callback: (res) => {
              if (res.res_code === '200') {
                let snackBarOptions = {
                  text: this.$t('common.message.modify.success')
                }
                eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)
                this.fnHideTemporaryModDialog()
                this.fnGetTemporaryList()
              }else{
                if (res.res_code === '401012') {
                  utils.setTokenRefresh().then(() => {
                    this.fnTemporaryModBtn()
                  })
                } else {
                  eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                }
              }
            }
          })
        } else {
          //2020-11-03 : 첫번째 에러 항목으로 Focus 되도록 추가 수정 (vee-validate 3.0 기반)
          document.getElementsByClassName('error--text')[0].scrollIntoView(false)
        }
      })
    },
    fnTemporaryDeleteConfirm(seq){
      let options = {
        title: this.$t('common.message.delete.confirm.title'),
        text: this.$t('common.message.delete.confirm.text'),
        yes: {
          text: this.$t('common.button.yes'),
          event: 'deleteTemporary',
          callback: {
            seq: seq
          }
        },
        no: {
          text: this.$t('common.button.no')
        }
      }
      eventBus.$emit('SHOW_CONFIRM_DIALOG'+ this.id, options)
    },
    fnDeleteTemporary(obj){
      requestApi({
        url: '/receivings/' + this.$route.params.receipt_no + '/temporary/' + obj.seq,
        method: 'DELETE',
        callback: (res) => {
          if (res.res_code === '200') {
            eventBus.$emit('CLOSE_CONFIRM_DIALOG'+ this.id)
            let snackBarOptions = {
              text: this.$t('common.message.delete.success')
            }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)
            this.fnGetTemporaryList()
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnDeleteTemporary(obj)
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    // 이전 화면으로 이동
    fnGoBefore(){
      this.loadingBefore = true
      this.$router.push({ path : '/application/patent/step1/' + this.$route.params.receipt_no })
    },
    // 다음 화면으로 이동
    fnGoNext(){
      if(this.$refs.component_applicants.applicants.length < 1){
        let option = {
          text : this.$t('component.applicants.msg_validate_fail_size'),
        }
        eventBus.$emit('SHOW_SNACKBAR', option)

        return false
      }

      if(this.$refs.component_inventors.inventors.length < 1){
        let option = {
          text : this.$t('component.inventor.msg_validate_fail_size'),
        }
        eventBus.$emit('SHOW_SNACKBAR', option)

        return false
      }

      if(this.$refs.component_representative.representatives.length < 1){
        let option = {
          text : this.$t('component.representative.msg_validate_fail_size'),
        }
        eventBus.$emit('SHOW_SNACKBAR', option)

        return false
      }

      if(this.$refs.component_applicants.auto_exist_yn){
        let option = {
          text : this.$t('component.applicants.msg_auto_check'),
        }
        eventBus.$emit('SHOW_SNACKBAR', option)

        return false
      }

      if(this.$refs.component_inventors.auto_exist_yn){
        let option = {
          text : this.$t('component.inventor.msg_auto_check'),
        }
        eventBus.$emit('SHOW_SNACKBAR', option)

        return false
      }

      if(this.$refs.component_representative.auto_exist_yn){
        let option = {
          text : this.$t('component.representative.msg_auto_check'),
        }
        eventBus.$emit('SHOW_SNACKBAR', option)

        return false
      }

      this.loadingNext = true

      requestApi({
        url: '/receivings/patent/' + this.$route.params.receipt_no + '/application',
        method: 'PUT',
        callback: (res) => {
          if (res.res_code === '200') {
            let snackBarOptions = {
              text: this.$t('common.message.add.success')
            }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)
            this.$router.push({ path : '/application/patent/step3/' + this.$route.params.receipt_no })
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGoNext()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
              this.loadingNext = false
            }
          }
        }
      })
    },
    formatDate (date) {
      if (!date) return ''
      const [year, month, day] = date.split('-')
      return `${day}-${month}-${year}`
    },
    formatDate2 (date) {
      if (!date) return ''
      const [day, month, year] = date.split('-')
      return `${year}-${month}-${day}`
    },
    formatViewDate (date) {
      if (!date) return ''
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    convertDateForm(date){
      if (!date) return ''
      return date.split('-').join('/')
    },
    fnIsNull(val){
      return utils.isNull(val)
    }
  },
}
</script>